/**
 * Project submodule.
 *
 * DEPRECATED. DO NOT USE ANYMORE.
 *
 * @deprecated
 */
interface ProjectSubmodule {

  /** Submodule id. */
  _id: string;

  /* Submodule state. */
  active: boolean;

  /** PvE Document chapter. */
  chapter: string | -1;

  /** Submodule's children. */
  children?: any[];

  /** Creation date as ISO string. */
  created: string;

  /** Disabled state. */
  disabled: boolean;

  /** Collection of submodule's child elements. */
  elements: ProjectElement[];

  /** Hide status. */
  hide: boolean;

  /** Parent module id. */
  moduleId: string;

  /** Parent submodule id. */
  moduleName: string;

  /** Submodule name. */
  name: string;

  /** Submodule order. */
  order: number;

  /** Protection status. */
  protected: boolean;

  /** Selected state. */
  selected: boolean;

  /** Template id. */
  templateId: string;

  /** Last updated as ISO string. */
  updated: string;

};
